import React from "react";
import { useTranslation } from "react-i18next";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { formatBetNumber } from "../common/utils/formatBetNumber";
import { getBetTypeLabel } from "../common/utils/betTypeLabel";

// Name lookup comes from `codeMeta` (numadd.jsx, derived from the current
// lotto type's own rewardTypeGroups — the same source "รายการที่เลือก"
// uses) instead of a separate, unfiltered /getLottoRewardTypes fetch,
// which didn't reliably have every code (e.g. run_top_mid, run_bot_end)
// for the lotto type actually being bet on.
function Lottotypeformodal(props) {
  const { t } = useTranslation();
  const handleDelete = props.handleDelete;
  const handleChange = props.handleChange;

  return (
    <div className="flex flex-col space-y-2 border-dashed border-b-[1px] border-slate-400">
      {Object.keys(props.grouparray).map((code) => (
        <table key={code} className="w-full border-collapse">
          <thead>
            <tr className="bg-slate-100 h-[40px]">
              <th className="w-[10%] md:w-[3%] text-left p-1 text-black font-bold text-[14px]">
                #
              </th>
              <th className="w-[30%] md:w-[45%] text-left p-1 text-red-500 font-bold text-[14px]">
                {getBetTypeLabel(code, props.codeMeta?.[code]?.name, t)}
              </th>
              <th className="w-[22%] text-left p-1 text-blue-500 font-bold text-[14px]">
                {t("numadd.rateMultiplier")}
              </th>
              <th className="text-left p-1 text-slate-600 font-bold text-[14px]">
                {t("numadd.winPayout")}
              </th>
            </tr>
          </thead>
          <tbody>
            {props.grouparray[code].map((data, index) => (
              <tr key={data.id} className="bg-white h-[40px]">
                <td className="text-center p-2 text-black font-bold text-[14px]">
                  {index + 1}.
                </td>
                <td className="p-1">
                  <div className="flex flex-row space-x-1">
                    <div className="w-[60px] shrink-0 bg-blue-300 px-[0.5rem] p-1 border-r-[2px] rounded">
                      <span className="font-bold text-[14px]">
                        {formatBetNumber(data.number)}
                      </span>
                    </div>
                    <input
                      type="text"
                      className="w-[100px] shrink-0 border-[1px] border-black rounded p-1 text-[14px]"
                      value={
                        data.bet_amout === 0
                          ? ""
                          : Number(data.bet_amout).toLocaleString("th-TH")
                      } // If bet_amout is 0, show an empty string as value
                      placeholder={
                        data.bet_amout === 0 ? t("numadd.setPrice") : ""
                      }
                      onChange={(e) => handleChange(e, data.id)}
                      min={1}
                    ></input>
                  </div>
                </td>
                <td className="p-1 text-left text-[14px]">
                  {Math.round(Number(data.bet_payrate)).toLocaleString(
                    "th-TH",
                  )}
                </td>
                <td className="p-1">
                  <div className="flex flex-row items-center justify-between space-x-1">
                    <span className="text-[14px]">
                      {(
                        Number(data.bet_amout) * Number(data.bet_payrate)
                      ).toLocaleString("th-TH")}
                    </span>
                    <button
                      onClick={() => handleDelete(data.id)}
                      className="bg-red-500 hover:bg-red-700 text-white font-bold p-1 rounded"
                    >
                      <DeleteForeverIcon fontSize="small" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </div>
  );
}

export default Lottotypeformodal;
